/**
 * isPersonaStaff — merkezi staff kontrolu (backend is_persona_staff:server.py:475 aynasi).
 * Staff = plan_type "persona_staff" VEYA email @personaajans.com VEYA is_staff.
 * Kredi-gate'lerde plan_type-only yerine bunu kullan (email-domain staff'i kacirmasin).
 */
export function isPersonaStaff(user) {
  if (!user) return false;
  if (user.plan_type === "persona_staff") return true;
  const email = (user.email || "").toLowerCase();
  if (email.endsWith("@personaajans.com")) return true;
  if (user.is_staff) return true;
  return false;
}
